import { Link } from "react-router-dom";

const faqs = [
  {
    q: "What does Blessings Connection LLC sell?",
    a: "Blessings Connection LLC sells new books, textbooks, educational materials, and related reading products through our online store.",
  },
  {
    q: "Where do you ship?",
    a: "We currently ship to customers within the United States.",
  },
  {
    q: "How long does it take to receive my order?",
    a: "Orders are processed within 2–4 business days after payment has been received and verified. Estimated delivery time is 2–8 business days after the order has been shipped. Delivery estimates are not guaranteed and may be affected by carrier performance, holidays, weather, and other circumstances.",
  },
  {
    q: "How do I track my order?",
    a: "Once your order has been shipped, we will send a shipping confirmation email containing tracking information to the email address you used at checkout. You can also use the Track Order page on our website to look up your order.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept major credit and debit cards through our secure payment provider, Stripe. Your card information is processed by Stripe and is never stored on our servers.",
  },
  {
    q: "Can I cancel an order?",
    a: "Orders may be cancelled before they have entered the shipping process. Once an order has been shipped, it can no longer be cancelled. If you no longer want the item, please refer to our Return & Refund Policy.",
  },
  {
    q: "What is your return policy?",
    a: "We accept returns within 15 days of the delivery date for eligible items. Items must be in their original condition and include all original packaging. Please review our Return & Refund Policy for full details.",
  },
  {
    q: "Who pays for return shipping?",
    a: "Customers are responsible for return shipping costs, except when the item received is damaged, defective, or incorrect. In those cases, Blessings Connection LLC will cover the return shipping cost and provide a prepaid return label.",
  },
  {
    q: "How long do refunds take to process?",
    a: "Once we receive and inspect your returned item, eligible refunds are issued to the original payment method. Refund processing times may vary depending on your financial institution, but most refunds appear within 5–10 business days after processing.",
  },
  {
    q: "How can I contact customer support?",
    a: "You can reach our customer support team by email at customerservice@blessingsconnection.com. Our team aims to respond within 1–2 business days.",
  },
];

export default function FAQ() {
  return (
    <div className="pt-28 md:pt-32 pb-20 bg-[#F9F6F0]" data-testid="faq-page">
      <div className="max-w-[800px] mx-auto px-6">
        <h1 className="text-3xl md:text-4xl font-semibold text-slate-900 text-center mb-3" data-testid="faq-title">
          Frequently Asked Questions
        </h1>
        <p className="text-sm text-slate-500 text-center mb-10">
          Answers to the most common questions about ordering, shipping, and returns.
        </p>

        <div className="space-y-6 text-base leading-relaxed text-slate-700">
          {faqs.map((f, idx) => (
            <section key={f.q} data-testid={`faq-item-${String(idx + 1).padStart(2, "0")}`}>
              <h2 className="text-lg font-medium mt-6 mb-2 text-slate-900">{f.q}</h2>
              <p>{f.a}</p>
            </section>
          ))}

          <section className="border-t border-slate-200 pt-8 mt-10" data-testid="faq-section-more">
            <h2 className="text-xl font-medium mb-3 text-slate-900">Still have a question?</h2>
            <p>
              If you did not find the answer you were looking for, please{" "}
              <Link to="/contact" className="text-slate-900 underline hover:text-[#7A2021]">
                contact our customer support team
              </Link>
              . We aim to respond within 1–2 business days.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/shipping"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Shipping policy
              </Link>
              <Link
                to="/returns"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Return policy
              </Link>
              <Link
                to="/terms"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Terms &amp; Conditions
              </Link>
            </div>
          </section>

          <div className="border-t border-slate-200 pt-6 mt-10">
            <p className="text-sm text-slate-500">
              Blessings Connection LLC · blessingsconnection.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
